export default "__VITE_ASSET__da9b2505__"